export const USER_LIST = 'USER_LIST';

export const AREA_LIST = 'AREA_LIST';

export const PRODUCT_LIST = 'PRODUCT_LIST';

export const CUSTOMER_LIST = 'CUSTOMER_LIST';
export const CUSTOMER_AREA_FILTER = 'CUSTOMER_AREA_FILTER';
export const CUSTOMER_COMPANY_NAME_FILTER = 'CUSTOMER_COMPANY_NAME_FILTER';

export const PRICELIST_LIST = 'PRICELIST_LIST';
export const PRICELIST_CUSTOMER_FILTER = 'PRICELIST_CUSTOMER_FILTER';
export const PRICELIST_CURRENT = 'PRICELIST_CURRENT';

export const ORDER_LIST = 'ORDER_LIST';
export const ORDER_DATE_FILTER = 'ORDER_DATE_FILTER';
export const ORDER_DATE_RANGE_FILTER = 'ORDER_DATE_RANGE_FILTER';

export const AUTH_USER_UPDATE = 'AUTH_USER_UPDATE';
export const AUTH_LOG_IN = 'AUTH_LOG_IN';
export const AUTH_LOG_OUT = 'AUTH_LOG_OUT';

export const DELIVERY_NOTE_LIST = 'DELIVERY_NOTE_LIST';
export const DELIVERY_NOTE_LIST_CLEAR = 'DELIVERY_NOTE_LIST_CLEAR';
export const DELIVERY_NOTE_DATE_FILTER = 'DELIVERY_NOTE_DATE_FILTER';
export const DELIVERY_NOTE_CUSTOMER_FILTER = 'DELIVERY_NOTE_CUSTOMER_FILTER';

export const INVOICE_DATA_CURRENT = 'INVOICE_DATA_CURRENT';
export const INVOICE_DATA_FILTER = 'INVOICE_DATA_FILTER';

export const APP_SUBMIT_PROTECTION_ENABLE = 'APP_SUBMIT_PROTECTION_ENABLE';
export const APP_SUBMIT_PROTECTION_DISABLE = 'APP_SUBMIT_PROTECTION_DISABLE';
export const APP_CONFIGURATION_LOAD = 'APP_CONFIGURATION_LOAD';
export const APP_LOADING_DATA_ENABLE = 'APP_LOADING_DATA_ENABLE';
export const APP_LOADING_DATA_DISABLE = 'APP_LOADING_DATA_DISABLE';



// WEBPACK FOOTER //
// ./client/store/mutationTypes.js